import { InjectionToken } from '@angular/core';

/**
 * Removes `finder-` prefixed classes from the body element
 *
 * @param body Body element
 * @param renderer Renderer object
 */
export const removeFinderClasses = (body, renderer) => {
    // First we have to walk the array to flag for removal
    const removals = [];

    // @SSR: There is no `forEach` on `classList` so we do this the old fashion way
    for(let i = 0; i < body.classList.length; i++) {
        if (body.classList[i].startsWith('finder-')) {
            removals.push(body.classList[i]);
        }
    }

    // We cannot remove them inline or it borks the array, so remove them now
    removals.forEach(removal => {
        renderer.removeClass(body, removal);
    });
};

export type RemoveFinderClassesProvider = (body: any, renderer: any) => void;
export const REMOVE_FINDER_CLASSES =
    new InjectionToken('REMOVE_FINDER_CLASSES', {
        factory: () => removeFinderClasses
    });
